<template>
  <!-- 出荷準備詳細 -->
  <div id="HSTShippingDetail">
    <div id="container">
      <div class="labelTitle lable">睡眠検査機器配送ｻｰﾋﾞｽ 出荷準備</div>
      <div class="button-area">
        <b-button
          class="backButton is-primary"
          @click="back"
        >戻る</b-button>
      </div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr><th>受付番号</th>
              <td>
                <span v-for="(num, index) in data.receiptNumber" :key="index"><span v-if="index >0"> , </span>{{num}}</span>
              </td>
            </tr>
            <tr><th>台数</th><td>{{data.units}}</td></tr>
            <tr><th>送り状番号<span class="require" /></th><td><input type="text" v-model="data.invoiceNumber" :disabled="!data.editFlag" maxlength="14"/></td></tr>
            <tr><th>配送先</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">〒{{data.zip}} {{data.shippingAddress}}</td></tr>
            <tr><th>宛名</th><td>{{data.receiverName}}</td></tr>
            <tr><th>連絡先(電話番号)</th><td>{{data.phoneNumber}}</td></tr>
            <tr><th>出荷日</th><td>{{data.shippingDate}}</td></tr>
            <tr>
              <th>ePatch同梱の有無</th>
              <td v-if="data.holterRequestId">有</td>
              <td v-else>無</td>
            </tr>
            <tr><th>配達希望時間帯</th><td>{{data.desiredDeliveryTimeZone | getNameFilter(desiredDeliveryTimeZoneList)}}</td></tr>
            <tr>
              <th style="vertical-align:top;">患者備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patientNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">配送備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.DeliveryInformationNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">受付備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.receptionNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">外部ユーザーコメント</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.belongsNote}}</td>
            </tr>
          </table>
        </div>
        <template v-for="(item, index) in data.deviceInfoList">
          <div class="card-content margin-top" :key="index">
            <span style="font-size:20px;">機器情報{{index+1}}</span>
            <table>
              <tr><th>受付番号</th><td colspan="2">{{item.receiptNumber}}</td></tr>
              <tr>
                <th>着払い番号<span class="require" /></th>
                <td><input type="text" v-model="item.paymentNumber" :disabled="!data.editFlag" maxlength="14"/></td>
              </tr>
              <tr><th>機種</th><td colspan="2">{{item.instrumentKind}}</td></tr>
              <tr v-if="isWP300(item.instrumentKind)">
                <th>いびきセンサー同梱の有無</th>
                <td>{{setSnoreSensorValue(item.snoreSensor)}}</td>
              </tr>
              <tr><th>シリアルナンバー</th>
                <td style="width:280px; vertical-align:middle;">{{item.serial}}</td>
                <td>
                  <b-button
                    style="width:150px;"
                    class="receptionistButton is-primary"
                    @click="returnPreparation(item.receiptNumber,item.serial)"
                    :disabled="!data.editFlag"
                  >機器準備中に戻す</b-button>
                </td>
              </tr>
              <tr v-if="isNightGraf(data.modelId)"><th>電極のロット</th><td colspan="2">{{item.electrodeLot}}</td></tr>
              <tr v-if="isNightGraf(data.modelId)"><th>カニューラのロット</th><td colspan="2">{{item.cannulaLot}}</td></tr>
              <tr><th>患者名</th><td colspan="2">{{item.patientName}}</td></tr>
              <tr><th>カニューラサイズ</th><td colspan="2">{{item.cannulaSize | getNameFilter(cannulaSizeList)}}</td></tr>
              <tr><th>ベルトサイズ</th><td colspan="2">{{item.beltSize | getNameFilter(beltSizeList)}}</td></tr>
            </table>
          </div>
        </template>
        <div class="button-area">
          <b-button
            class="receptionistButton is-primary"
            @click="registNumber"
            :disabled="!data.editFlag"
          >番号登録</b-button>
          <b-button
            class="receptionistButton is-primary"
            @click="doShipping"
            :disabled="!data.editFlag"
          >出荷済みにする</b-button>
          <b-button
            class="backButton is-primary"
            @click="back"
          >戻る</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {choicesType} from "@/components/mock/base/const.js";
import {LendingPeriod} from "@/components/mock/base/const.js";
import {hstModelValue} from "@/components/mock/base/const.js";
export default {
  name: "HSTShippingDetail",
  methods: {
    doSearch: function() {
      var excuteApi = this.getHstDeviceShipmentDetailPOST;
      var successCallBack = this.getHstDeviceShipmentDetailPOSTSuccess;
      var errorCallBack = this.getHstDeviceShipmentDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHstDeviceShipmentDetailPOST: function(client) {
      return client.apis.internalHst.getHstDeviceShipmentDetailPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getHstDeviceShipmentDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
    },
    getHstDeviceShipmentDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result,this.back());
    },
    back: function() {
      this.$router.push({
        name: "HSTShippingList",
        params: { searchConditions: this.searchParams },
      });
    },
    registNumber: function() {
      var paymentNumberList = this.data.deviceInfoList.filter(val => val.paymentNumber)
      if(!this.data.invoiceNumber && paymentNumberList.length==0){
        this.showErrorMessage("番号が入力されていません。")
        return
      }

      var excuteApi = this.setHstNumberPOST;
      var successCallBack = this.setHstNumberPOSTSuccess;
      var errorCallBack = this.setHstNumberPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHstNumberPOST: function(client) {
      var obj = []
      for(let item of this.data.deviceInfoList){
        var req = {
          receiptNumber: item.receiptNumber,
          invoiceNumber: this.data.invoiceNumber ? this.data.invoiceNumber : "",
          paymentNumber: item.paymentNumber ? item.paymentNumber : ""
        }
        obj.push(req)
      }
      return client.apis.internalHst.setHstNumberPOST({
        body: obj
      });
    },
    setHstNumberPOSTSuccess: function(result) {
      // 検索結果取得
      this.showSuccess(result,this.back());
    },
    setHstNumberPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    doShipping: function() {
      var noPaymentNumberList = this.data.deviceInfoList.filter(val => !val.paymentNumber)
      if(!this.data.invoiceNumber || noPaymentNumberList.length>0){
        this.showErrorMessage("「送り状番号」「着払い番号」を入力してください。")
        return
      }
      var excuteApi = this.setHstDeviceShipmentPOST;
      var successCallBack = this.setHstDeviceShipmentPOSTSuccess;
      var errorCallBack = this.setHstDeviceShipmentPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHstDeviceShipmentPOST: function(client) {
      var obj = []
      var returnDate = this.getBusinessDay(new Date(), this.lendingPeriod);
      returnDate = this.yyyy_sla_MM_sla_dd(returnDate)
      for(let item of this.data.deviceInfoList){
        var req = {
          receiptNumber: item.receiptNumber,
          invoiceNumber: this.data.invoiceNumber ? this.data.invoiceNumber : "",
          paymentNumber: item.paymentNumber ? item.paymentNumber : "",
          returnDate: returnDate
        }
        obj.push(req)
      }
      return client.apis.internalHst.setHstDeviceShipmentPOST({
        body: obj
      });
    },
    setHstDeviceShipmentPOSTSuccess: function(result) {
      // 検索結果取得
      this.showSuccess(result,this.back());
    },
    setHstDeviceShipmentPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    returnPreparation: function(receiptNumber,serial) {
      this.reqParams = {
        receiptNumber:receiptNumber,
        serial:serial
      }
      var messsage = "設定済みのシリアル及び送り状番号/着払い番号は解除されます。機器準備中に戻しますか？";
      this.$dialog.confirm({
        title: "解除確認",
        message:messsage,
        cancelText: "キャンセル",
        onConfirm: async () => {
          var excuteApi = this.setHstDeviceShipmentReturnPOST;
          var successCallBack = this.setHstDeviceShipmentReturnPOSTSuccess;
          var errorCallBack = this.setHstDeviceShipmentReturnPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
        }
      })
    },
    setHstDeviceShipmentReturnPOST: function(client) {
      return client.apis.internalHst.setHstDeviceShipmentReturnPOST({
        body:this.reqParams
      });
    },
    setHstDeviceShipmentReturnPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result)
      if(this.data.deviceInfoList.length == 1){
        this.back()
        return
      }
      this.targetNumber = this.targetNumber.filter(val => val != this.reqParams.receiptNumber)
      this.reqParams.receiptNumber = ""
      this.reqParams.serial = ""
      this.doSearch();  //再検索
      this.jumpToTop(); //画面を上部に移動
    },
    setHstDeviceShipmentReturnPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }, 
    isWP300: function(instrumentKind) {
      if(instrumentKind && instrumentKind.match(/ウォッチパット300/)){
        return true
      }
      return false
    },
    setSnoreSensorValue: function(snoreSensor) {
      var setSnoreSensorValue = snoreSensor ? "有" : "無";
      return setSnoreSensorValue;
    },
    isNightGraf: function(modelId) {
      if(modelId == hstModelValue.NIGHTGRAF){
        return true
      }
      return false
    },
  },
  data() {
    var targetNumber = this.$route.params["receiptNumber"];
    var searchParams = this.$route.params["searchConditions"];
    var modelList = this.getChoiceList(choicesType.hstKind, false);
    var desiredDeliveryTimeZoneList = this.getChoiceList(choicesType.deliveryTime, false);
    var cannulaSizeList = this.getChoiceList(choicesType.cannulaSize, false);
    var beltSizeList = this.getChoiceList(choicesType.beltSize, false);
    return {
      data: {},
      targetNumber,
      searchParams,
      modelList,
      desiredDeliveryTimeZoneList,
      cannulaSizeList,
      beltSizeList,
      lendingPeriod:LendingPeriod.period,
      reqParams:{
        receiptNumber:"", //受付番号
        serial:""         //シリアル
      }
    };
  },
  async mounted() {
    // 詳細情報取得
    await this.doSearch();
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {}
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}

.delay {
  font-weight: bold;
}
.delay,
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/hst/HSTShippingDetail.vue